<template>
  <span>
    <template v-if="object.status == 2">
      <span class="text-danger">{{ $t('cancelled') }}</span>
      <!--  cancelled -->
      <span class="text-danger" v-if="reason"> - {{ reason }}</span>
    </template>
    <template v-else>
      <div>
        {{ $t(object.readableStatus) }}
        <!--  did not come -->
        <span class="text-danger" v-if="reason && object.records_statuses_id == 5"> - {{ reason }}</span>
      </div>
      <div v-if="object.price > 0">
        <span class="text-danger" v-if="object.is_paid === '0'">{{ $t('debt') }}</span>
        <span class="text-success" v-if="object.is_paid === '1'">{{ $t('paid') }}</span>
      </div>
    </template>
    <div v-if="object.controlSystemStatus"
         class="small mt-1 text-muted">
      {{ $t(object.controlSystemStatus) }}
    </div>
  </span>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "PatientsDatatableTDRecordStatus",
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    reason() {
      return this.object.record_reasons?.[0]?.reason || null
    },
    ...mapState({
      rights: state => state.auth.rights,
    }),
  },
}
</script>
